import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type State = {
	trainId: number;
};

const INITIAL_STATE: State = {
	trainId: 0,
};

export const appSlice = createSlice({
	name: 'app',
	initialState: INITIAL_STATE,
	reducers: {
		toggleTrainId: (state, action: PayloadAction<number>) => {
			state.trainId = action.payload;
		},
	},
});
